import { Trans } from "@web-monorepo/i18n/macro";
import { DDSBodyText, DDSHeadlineText } from "@web-monorepo/dds";
import { Lesson, Slide } from "src/pods/ideas/data/types";
import styles from "./Watch.module.css";

function WatchCardContent({ title, timing }: { title?: string; timing?: string }) {
  return (
    <div className={styles.cardContent}>
      {/* Board supplies h1, so use h2. DDSHeadlineText has no variant prop; .title supplies
          --content-on-media to preserve the white heading over the poster. */}
      <DDSHeadlineText as="h2" level="md" className={styles.title}>
        {title}
      </DDSHeadlineText>
      {timing ? (
        <DDSBodyText variant="light" className={styles.timing}>
          {timing}
        </DDSBodyText>
      ) : (
        <DDSBodyText variant="light" className={styles.timing}>
          <Trans>3 minute video</Trans>
        </DDSBodyText>
      )}
    </div>
  );
}

export default function Watch({
  lesson,
  watch,
  timing,
  onClick,
}: {
  watch: Slide;
  lesson: Lesson;
  timing?: string;
  onClick: VoidFunction;
}) {
  if (watch.type !== "hls") return null;

  return (
    <button
      type="button"
      data-name="watch:card"
      className={styles.card}
      style={{ backgroundImage: `url(${watch.poster_url})` }}
      onClick={onClick}
    >
      <WatchCardContent title={lesson.title} timing={timing} />
    </button>
  );
}
